import type { FireAnalyticsEvent } from '../../types';

type CacheRequestName = 'search-config' | `search-3p-config` | 'outbound-auth-github';

type onCacheAccessArgs = {
	requestName: CacheRequestName;
	searchSessionId: string;
	cacheHit: boolean;
	refreshTriggered: boolean;
	source: string;
};

// Record the hit/miss rate of request caching
export const onRequestCacheAccess = ({
	requestName,
	searchSessionId,
	cacheHit,
	refreshTriggered,
	source,
}: onCacheAccessArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'requestCacheAccess',
		actionSubject: 'searchPage',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				requestName,
				cacheHit,
				refreshTriggered,
				searchSessionId,
			},
		},
	};
};
